import { render } from "./draggable-number.vue?vue&type=template&id=52f26fb0"
import script from "./draggable-number.vue?vue&type=script&lang=js"
export * from "./draggable-number.vue?vue&type=script&lang=js"

import exportComponent from "/Users/benjamin/Sites/hyper-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__